<template>
  <div class="mains">
    <div class="campus">功能模块 <span>></span> 趣配音统计</div>
    <div class="pane" v-if="data">
      <div class="cards">
        <div class="card"><b>{{ data.todayWorks }}</b><span>今日新增作品</span></div>
        <div class="card"><b>{{ data.totalWorks }}</b><span>累计配音作品</span></div>
        <div class="card"><b>{{ data.activeUsers }}</b><span>7 日活跃配音用户</span></div>
      </div>
      <p class="note" v-if="data.unassignedWorks">另有 {{ data.unassignedWorks }}
        件作品没有生成时的机构，单独列出，不并进已知机构。</p>
      <h4>近 7 日活跃机构</h4>
      <div class="bars">
        <div v-for="item in data.orgBars" :key="item.orgName" class="bar">
          <span>{{ item.orgName }}</span>
          <i :style="{ width: width(item.works) }"></i>
          <em>{{ item.works }}</em>
        </div>
        <div v-if="!(data.orgBars || []).length" class="empty">这 7 天还没有作品</div>
      </div>
      <h4>章节配音 TOP5</h4>
      <el-table :data="data.chapterTop" border>
        <el-table-column type="index" label="排名" width="70"/>
        <el-table-column prop="chapterTitle" label="章节"/>
        <el-table-column prop="works" label="累计作品" width="120"/>
      </el-table>
      <h4>机构数据</h4>
      <el-table :data="data.organizations" border>
        <el-table-column type="index" label="序号" width="70"/>
        <el-table-column prop="orgName" label="机构"/>
        <el-table-column prop="students" label="学生总数"/>
        <el-table-column prop="activeUsers" label="7 日活跃"/>
        <el-table-column prop="totalWorks" label="累计作品"/>
        <el-table-column prop="weekWorks" label="7 日新增"/>
        <el-table-column label="人均作品">
          <template slot-scope="scope">{{ scope.row.average === null ? '—' : scope.row.average }}</template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :current-page="page" :page-size="10"
                     :total="data.orgTotal || 0" @current-change="load"/>
      <p class="note">统计时点 {{ data.updatedAt }}。口径按上海自然日，只计已生成且未删除的作品。</p>
    </div>
    <div v-else class="pane">
      <el-button type="primary" @click="load(1)">重试</el-button>
    </div>
  </div>
</template>

<script>
/** 按上海时区自然日统计已生成作品。 */
export default {
  name: 'dubbingStats',
  data() {
    return {data: null, page: 1};
  },
  created() {
    this.load(1);
  },
  methods: {
    // 机构表分页。未归属作品单独计数。
    load(page) {
      this.page = page;
      const token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      this.$http({
        url: '/edu/dubbing/statistics',
        method: 'GET',
        headers: {Authorization: 'Bearer ' + token},
        params: {page, pageSize: 10}
      })
        .then((res) => {
          if (res.data.code !== 0) return this.$message.error(res.data.message);
          this.data = res.data.data;
        })
        .catch(() => {
          this.data = null;
          this.$message.error('统计加载失败');
        });
    },
    width(works) {
      const max = Math.max(...(this.data.orgBars || []).map((item) => Number(item.works) || 0), 1);
      return Math.max(8, Math.round((Number(works) || 0) * 220 / max)) + 'px';
    },
  },
};
</script>

<style scoped>
.pane {
  background: #fff;
  padding: 16px;
}

.cards {
  display: flex;
  gap: 12px;
}

.card {
  flex: 1;
  background: #f7f4ee;
  padding: 16px;
}

.card b {
  display: block;
  font-size: 28px;
}

.bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 0;
}

.bar i {
  display: inline-block;
  height: 12px;
  background: #e37b32;
}

.note, .empty {
  color: #888;
  font-size: 12px;
}
</style>
